import { useContext } from "react";
import { Button, colors, Grid, IconButton, Stack, styled, Toolbar } from "@mui/material";
import { UserInfoContext } from "./contexts/UserInfoContext";
import LogoutIcon from '@mui/icons-material/Logout';
import IndexLogoContainer from "./components/IndexLogoContainer.tsx";
import { MainTabContext, TAB_NAMES } from "./contexts/MainTabContext";

const NavButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active?: boolean }>(({ theme, active }) => {
  return {
    borderRadius: 0,
    color: active ? theme.palette.primary.main : "inherit",
    boxShadow: active ? `inset 0 -2px 0 0 ${theme.palette.primary.main}` : "none",
    "&:hover": {
      boxShadow: active
        ? `inset 0 -2px 0 0 ${theme.palette.primary.main}`
        : `inset 0 -2px 0 0 ${colors.grey[300]}`,
    },
  }
});

const TooltipButtonIcon = styled(IconButton)(() => {
  return {
    background: "white",
    borderColor: colors.grey[100],
    color: colors.grey[800],
    borderRadius: "4px",
    borderStyle: "solid",
    borderWidth: "1px",
    width: "32px",
    height: "32px",
    "&:hover": {
      background: colors.grey[100],
    },
    '& .MuiTouchRipple-root': {
      borderRadius: 0
    },
  }
});

function Header() {
  const { onLogout, isEmployee, hasNationalPrivatePlacements } = useContext(UserInfoContext);
  const { activeTab, setActiveTab } = useContext(MainTabContext);

  return (
    <Toolbar sx={{ background: "white" }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        width="100%"
      >

        {/* Logo */}
        <IndexLogoContainer />

        {/* Pages */}
        <Stack 
          direction="row" 
          gap={1}
          color={colors.grey[900]}
          sx={{ display: { xs: 'none', lg: 'block' } }}
        >
          <NavButton active={activeTab === TAB_NAMES.MARKET_MONITOR} onClick={() => setActiveTab(TAB_NAMES.MARKET_MONITOR)} color="inherit">MARKET MONITOR</NavButton>
          {(isEmployee() || hasNationalPrivatePlacements()) && <NavButton active={activeTab === TAB_NAMES.NATIONAL_PRIVATE_PLACEMENTS} onClick={() => setActiveTab(TAB_NAMES.NATIONAL_PRIVATE_PLACEMENTS)} color="inherit">NATIONAL PRIVATE PLACEMENTS</NavButton>}
          <NavButton active={activeTab === TAB_NAMES.DEAL_BUILDER} onClick={() => setActiveTab(TAB_NAMES.DEAL_BUILDER)} color="inherit">DEAL BUILDER</NavButton>
          <NavButton active={activeTab === TAB_NAMES.PRICING_MANAGEMENT} onClick={() => setActiveTab(TAB_NAMES.PRICING_MANAGEMENT)} color="inherit">DEAL MANAGEMENT</NavButton>
          {<NavButton active={activeTab === TAB_NAMES.ANALYSIS} onClick={() => setActiveTab(TAB_NAMES.ANALYSIS)} color="inherit">ANALYSIS</NavButton>}
          {isEmployee() && <NavButton active={activeTab === TAB_NAMES.ADMIN} onClick={() => setActiveTab(TAB_NAMES.ADMIN)} color="inherit">ADMIN</NavButton>}
        </Stack>

        {/* Actions */}
        <Stack direction="row" gap={1}>
          <TooltipButtonIcon onClick={onLogout}>
            <LogoutIcon fontSize="small" />
          </TooltipButtonIcon>
        </Stack>

      </Grid>
    </Toolbar>
  )
}

export default Header;
